import React  from "react";
import MyDocuments from "./components/MyDocuments";
import { useSelector } from "react-redux";

const EmployeeDocuments = () => {
  const user = useSelector((state) => state.auth.user);
  return (
    <MyDocuments employeeId={user.employee_id} />
  );
};

export default EmployeeDocuments;